import { InputAdornment } from '@mui/material';
import {
  mapDispatchLoanAmount,
  mapStateLoanAmount
} from 'reg_redesign/redux/connectFunctions';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import CurrencyMask from 'components/rebrand/CurrencyMask';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import React from 'react';

const moneyAdornment = {
  startAdornment: <InputAdornment position='start'>$</InputAdornment>
};

const page13 = {
  defaultNextPage: 'page-14',
  content: [
    configureProgressBar(83),
    configureTitle(['How much money are you looking to', 'borrow?']),
    {
      component: BasicInput,
      props: {
        id: 'loanAmount',
        label: 'Loan Amount Requested (optional)',
        type: 'text',
        isNumeric: true,
        adornment: moneyAdornment,
        InputProps: {
          inputComponent: CurrencyMask
        }
      },
      stateToPropsOverride: mapStateLoanAmount,
      dispatchOverride: mapDispatchLoanAmount
    },
    nextButtonConfig('page-13')
  ]
};

export default page13;
